import Badge from 'components/base/Badge';
import Button from 'components/base/Button';
import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Question } from './DataDefinitions';
import apiClient, { handleAPIError } from 'helpers/apiService';

const QuestionarieRO = ({
    data, title, assessment_id, onShare
}: { assessment_id: number, data: any, title?: string, onShare: (assessment_id: number) => void }
) => {
    const { t } = useTranslation();

    const questions: Question[] = data;
    const getBadgeVariant = (gap: number) => {
        if (gap <= -50) {
            return 'danger'; // Gap between -50 and -100
        } else if (gap <= -10) {
            return 'warning'; // Gap between -10 and -50
        } else {
            return 'success'; // Gap > -10
        }
    };

    const handleExportTranscription = async () => {
        /**
         * Get a feedback on the given conversation
         */
        try {
            // Send the file to the backend using Axios
            // ALT+96 -> ` /skills/assessments/{assessment_id}/report
            const response = await apiClient.get(`/v1/skills/assessments/${assessment_id}/report`, {
                responseType: 'blob', // Important for handling binary data
            });

            // Create a link element, set the href to the Blob URL, and trigger a download

            const fileType = 'application/pdf';
            const url = window.URL.createObjectURL(new Blob([response.data], { type: fileType }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf'); // Set the file name
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error requesting report pdf:', error);
        }
    };

    return (
        <div>

            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center pt-3 pb-2">
                    <h3 className="mb-0">{title}</h3>
                    <div className='d-flex gap-2'>
                        <Button variant="primary" onClick={() => handleExportTranscription()}>
                            {t("QuestionarieRO.get_report")}
                        </Button>
                        <Button variant="primary" onClick={() => onShare(assessment_id)}>
                            {t("QuestionarieRO.share_report")}
                        </Button>
                    </div>

                </Card.Header>
                <Card.Body className="pb-0">

                    <Accordion defaultActiveKey="0">
                        {questions.map((question, index) => (
                            <Accordion.Item key={index} eventKey={index + ""} className="border-top border-300">
                                <Accordion.Header>
                                    <div>
                                        {question.competence}
                                        <Badge bg={getBadgeVariant(question.evaluation - question.expected_level)} variant="phoenix" className='mx-4'>
                                            Gap: {question.evaluation - question.expected_level}
                                        </Badge>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body className="pt-0">
                                    {question.description}
                                    <br />
                                    <br />
                                    <strong>{t("QuestionarieRO.evaluation")} {question.evaluation}</strong>
                                    <br />
                                    <strong>{t("QuestionarieRO.target_level")} {question.expected_level}</strong>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Card.Body>
                <Card.Footer className="border-top-0">

                </Card.Footer>
            </Card>
        </div>
    );
};

export default QuestionarieRO;
